var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], {"dev":false,"autoescape":true,"throwOnUndefined":false,"trimBlocks":false,"lstripBlocks":false});
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../lib/nunjucks/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["components/backArrow.html"] = require( "components/backArrow.html" );
dependencies["components/escrowLogo.html"] = require( "components/escrowLogo.html" );
dependencies["components/escrowShield.html"] = require( "components/escrowShield.html" );




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["escrow_www/templates/navigation/simplifiedHeader.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = runtime.contextOrFrameLookup(context, frame, "force_show_back_button") || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"referrer") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"WWW_BASE_URL") && (lineno = 0, colno = 117, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"referrer")),"find"), "request[\"referrer\"][\"find\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"WWW_BASE_URL")])) == 0);
frame.set("show_back_button", t_1, true);
if(frame.topLevel) {
context.setVariable("show_back_button", t_1);
}
if(frame.topLevel) {
context.addExport("show_back_button", t_1);
}
output += "\n\n<div>\n  <header class=\"headerV3 is-header-scrollTop\" data-sticky-header data-header-type=\"simplified\">\n    <div class=\"headerV3-primary\">\n      <div class=\"headerV3-container section-container\">\n        <div class=\"headerV3-inner\">\n          ";
if(runtime.contextOrFrameLookup(context, frame, "show_back_button")) {
output += "\n            <button class=\"headerV3-menuBtn headerV3-returnUrl\" onclick=\"window.history.back()\">\n              ";
env.getTemplate("components/backArrow.html", false, "escrow_www/templates/navigation/simplifiedHeader.html", null, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
t_2.render(context.getVariables(), frame, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
output += t_3
output += "\n              <span>Back</span>\n            </button>\n          ";
})});
}
output += "\n          <a class=\"headerV3-logo media--hidden@mobile\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"ESCROW_LOGGEDIN_LANDING_PAGE"), env.opts.autoescape);
output += "\">\n            ";
env.getTemplate("components/escrowLogo.html", false, "escrow_www/templates/navigation/simplifiedHeader.html", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "\n          </a>\n          <div class=\"headerV3-shield media--available@mobile\">\n            ";
env.getTemplate("components/escrowShield.html", false, "escrow_www/templates/navigation/simplifiedHeader.html", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n          </div>\n        </div>\n      </div>\n    </div>\n  </header>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["escrow_www/templates/navigation/simplifiedHeader.html"] , dependencies)